var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeechBubbleXs = function SvgSpeechBubbleXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H13V10H3L3 3ZM1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V10C15 11.1046 14.1046 12 13 12H11.7321L10.866 13.5C10.4811 14.1667 9.51888 14.1667 9.13397 13.5L8.26795 12H3C1.89543 12 1 11.1046 1 10V3Z",
    fill: "currentColor"
  })));
};
export { SvgSpeechBubbleXs as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDNIMTNWMTBIM0wzIDNaTTEgM0MxIDEuODk1NDMgMS44OTU0MyAxIDMgMUgxM0MxNC4xMDQ2IDEgMTUgMS44OTU0MyAxNSAzVjEwQzE1IDExLjEwNDYgMTQuMTA0NiAxMiAxMyAxMkgxMS43MzIxTDEwLjg2NiAxMy41QzEwLjQ4MTEgMTQuMTY2NyA5LjUxODg4IDE0LjE2NjcgOS4xMzM5NyAxMy41TDguMjY3OTUgMTJIM0MxLjg5NTQzIDEyIDEgMTEuMTA0NiAxIDEwVjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";